import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Trend from '@/components/Trend'
import Review from '@/components/Review'
import Market from '@/components/Market'
import Chance from '@/components/Chance'
import Stocks from '@/components/Stocks'
import Risk from '@/components/Risk'
import Invest from '@/components/Invest'
import Feature from '@/components/Feature'
import Education from '@/components/Education'
import UCenter from '@/components/UCenter'
import Detail from '@/components/Detail'
import Search from '@/components/Search'
import InvestmentResearchLibrary from '@/components/InvestmentResearchLibrary'
import ArticleDetail from '@/components/ArticleDetail'
import ArticleDetailTwo from '@/components/ArticleDetailTwo'
import Member from '@/components/Member'
import Order from '@/components/Order'
import OrderTransfer from '@/components/OrderTransfer'
import OrderPay from '@/components/OrderPay'
import PaySuccess from '@/components/PaySuccess'
import Agreement from '@/components/Agreement'
import AgreementTransfer from '@/components/AgreementTransfer'
import Privacy from '@/components/Privacy'
import TransferReview from '@/components/TransferReview'

Vue.use(Router)


export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) { //如果savedPosition存在，滚动条会自动跳到记录的值的地方
      return savedPosition
    } else {
      return {x: 0, y: 0}//savedPosition也是一个记录x轴和y轴位置的对象
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Trend',
      name: 'Trend',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Trend
    },
    {
      path: '/Review',
      name: 'Review',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Review
    },
    {
      path: '/Market',
      name: 'Market',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Market
    },
    {
      path: '/Chance',
      name: 'Chance',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Chance
    },
    {
      path: '/Stocks',
      name: 'Stocks',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Stocks
    },
    {
      path: '/Risk',
      name: 'Risk',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Risk
    },
    {
      path: '/Feature',
      name: 'Feature',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Feature
    },
    {
      path: '/Education',
      name: 'Education',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Education
    },
    {
      path: '/Invest',
      name: 'Invest',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Invest
    },
    {
      path: '/UCenter',
      name: 'UCenter',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: UCenter
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/InvestmentResearchLibrary',
      name: 'InvestmentResearchLibrary',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: InvestmentResearchLibrary
    },
    {
      path: '/ArticleDetail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/ArticleDetailTwo',
      name: 'ArticleDetailTwo',
      component: ArticleDetailTwo
    },
    {
      path: '/Search',
      name: 'Search',
      meta: {
        keepAlive: true // 需要缓存
      },
      component: Search
    },
    {
      path: '/Member',
      name: 'Member',
      component: Member
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    },
    {
      path: '/OrderTransfer',
      name: 'OrderTransfer',
      component: OrderTransfer
    },
    {
      path: '/OrderPay',
      name: 'OrderPay',
      component: OrderPay
    },
    {
      path: '/PaySuccess',
      name: 'PaySuccess',
      component: PaySuccess
    },
    {
      path: '/Agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/AgreementTransfer',
      name: 'AgreementTransfer',
      component: AgreementTransfer
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/TransferReview',
      name: 'TransferReview',
      component: TransferReview
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js